module.exports = __webpack_public_path__ + "media/src/components/Home/HowItWorks/number-1-e49138e120b510eb2044b726a46f86e3.png";